import { Header, Footer, HomeHero, TrustBadges, AboutBlock, GalleryBlock, ServicesBlock, WhyUsBlock, LocationBlock, EstimateForm } from "@/components/site";

export default function Home() {
  return (
    <div className="bg-white text-slate-800">
      <Header />
      <HomeHero />
      <TrustBadges />
      <AboutBlock />
      <ServicesBlock />
      <GalleryBlock />
      <WhyUsBlock />
      <LocationBlock />
      <EstimateForm />
      <Footer />
    </div>
  );
}
